export const iconFontAwesomeAlphabetS = (
	<i className="fa-solid fa-s"></i>
);
